import React, { Component } from 'react';
import Snake from './snake';
import Food from './food';

var intervalID = 0;
var flag = false;
const _speed = 130;

const getRandomCoordinates = () => {
  let min = 1;
  let max = 98;
  let x = Math.floor((Math.random()*(max-min+1)+min)/2)*2;
  let y =  Math.floor((Math.random()*(max-min+1)+min)/2)*2;
  return [x,y]
}

const initialState = {
  food: getRandomCoordinates(),
  speed: _speed,
  direction: 'RIGHT',
  snakeDots: [
    [0,0],
    [2,0],
    [4,0]
  ]
}


class SnakeGame extends Component {

  state = initialState;
  

  componentDidMount() {
    intervalID = setInterval(this.moveSnake, this.state.speed)
    document.onkeydown = this.onKeyDown;
  }

  componentWillUnmount() {
    clearInterval(intervalID);
  }

  componentDidUpdate() {
    this.checkIfOutOfBorders();
    this.checkIfCollapsed();
    this.checkIfEat();
    if(flag){
      clearInterval(intervalID);
      intervalID = setInterval(this.moveSnake, _speed)
      flag = false
    }
  }
  
  onKeyDown = (e) => {
    e = e || window.event;
    if(this.state.direction==='RIGHT' || this.state.direction==='LEFT'){
      switch (e.keyCode){
        case 38:
        this.setState({direction: 'UP'});
        break;
      case 40:
        this.setState({direction: 'DOWN'});
        break;
      default:
      }
    }
    else if(this.state.direction==='UP' || this.state.direction==='DOWN'){
      switch (e.keyCode){
        case 37:
        this.setState({direction: 'LEFT'});
        break;
      case 39:
        this.setState({direction: 'RIGHT'});
        break;
      default:
      }
    }
  }

  moveSnake = () => {
    let dots = [...this.state.snakeDots];
    let head = dots[dots.length - 1];

    switch (this.state.direction) {
      case 'RIGHT':
        head = [head[0] + 2, head[1]];
        break;
      case 'LEFT':
        head = [head[0] - 2, head[1]];
        break;
      case 'DOWN':
        head = [head[0], head[1] + 2];
        break;
      case 'UP':
        head = [head[0], head[1] - 2];
        break;
      default:
    }
    dots.push(head);
    dots.shift();
    this.setState({
      snakeDots: dots
    })
  }

  checkIfOutOfBorders() {
    let head = this.state.snakeDots[this.state.snakeDots.length - 1];
    if (head[0] >= 100 || head[1] >= 100 || head[0] < 0 || head[1] < 0) {
      this.onGameOver();
    }
  }

  checkIfCollapsed() {
    let snake = [...this.state.snakeDots];
    let head = snake[snake.length - 1];
    snake.pop();
    snake.forEach(dot => {
      if (head[0] === dot[0] && head[1] === dot[1]) {
        this.onGameOver();
      }
    })
  }

  checkIfEat() {
    let head = this.state.snakeDots[this.state.snakeDots.length - 1];
    let food = this.state.food;
    if (head[0] === food[0] && head[1] === food[1]) {
      this.setState({
        food: getRandomCoordinates()
      })
      this.enlargeSnake();
      this.increaseSpeed();
    }
  }

  enlargeSnake() {
    let newSnake = [...this.state.snakeDots];
    newSnake.unshift([])
    this.setState({
      snakeDots: newSnake
    })
  }

  increaseSpeed() {
    if((this.state.snakeDots.length%3)===0){
      this.setState({
        speed: this.state.speed - 10
      })
      clearInterval(intervalID);
      intervalID = setInterval(this.moveSnake, this.state.speed)
    }
  }

  onGameOver() {
    alert(`Game Over. Your score is ${this.state.snakeDots.length}`);
    this.setState(initialState)
    flag = true
  }

  render() {
    return (
      <div className="game-area">
        <Snake snakeDots={this.state.snakeDots}/>
        <Food dot={this.state.food}/>
      </div>
    );
  }
}

export default SnakeGame;